import Route from '@ember/routing/route';

export default class RollReturnsRoute extends Route {}
